module.exports = __webpack_public_path__ + "img/PayNow_SG.bae7b088.png";